import { useEffect, useState } from "react";
import { useModal } from "../../contexts/ModalContext";
import { useToast } from "../../contexts/ToastContext";

import FormComp from "../../Componentes/FormComp";
import Overlay from "../../Componentes/Overlay";
import Formulario from "../../Componentes/Utils/Formulario";
import Modal from "../../Componentes/Utils/Modal";
import MultiFileUploader from "../../Componentes/Utils/MultiFileUploader";
import { useParams } from "react-router-dom";
import SmallLoading from "../../Componentes/Utils/SmallLoading";

import useApi from "../../hooks/useApi";
const ModalAddCandidato = ({ updateCandidatos }) => {
    const api = useApi();


    const { closeModal } = useModal();
    const { notifyError, notifySuccess } = useToast();

    const { cc, ano } = useParams();

    const [loading, setLoading] = useState(false);

    const [matricula, setMatricula] = useState("");
    const [nome, setNome] = useState("");
    const [funcao, setFuncao] = useState("");
    const [apelido, setApelido] = useState("");
    const [files, setFiles] = useState([]);

    const fetchCandidatoData = async (matricula) => {

        setLoading(true);

        try {
            const { data } = await api.get(`/Painel/API/Cipa/CandidatoInfo/index.php?matricula=${matricula}`);
            setNome(data.NOME);
            setFuncao(data.FUNCAO);

        } catch (error) {
            console.log(error);
            notifyError(error.response?.data?.message || "Erro ao buscar dados do candidato.");
        } finally {
            setLoading(false);
        }

    }

    useEffect(() => {

        if (matricula.length === 6) {
            fetchCandidatoData(matricula);
        } else {
            setNome("");
            setFuncao("");
        }

    }, [matricula])

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (files.length === 0) {
            notifyError("Adicione a foto do candidato.");
            return;
        }

        setLoading(true);

        try {
            const formData = new FormData();
            formData.append("matricula", matricula);
            formData.append("nome", nome);
            formData.append("funcao", funcao);
            formData.append("centro_custo", cc);
            formData.append("ano", ano);
            formData.append("apelido", apelido);
            files.forEach((f, index) => {
                formData.append(`file_${index}`, f.file);
            });

            await api.post("/Painel/API/Cipa/CadastrarCandidato/", formData,
                { headers: { "Content-Type": "multipart/form-data" } },
                { withCredentials: true }
            );

            await updateCandidatos();
            notifySuccess("Candidato cadastrado com sucesso!");
            closeModal();

        } catch (e) {
            console.log(e);
            notifyError("Erro ao salvar candidato.");
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <Overlay state={true} >
                <Modal size="md" close={closeModal} header={true} >
                    <Formulario onSubmit={handleSubmit} >
                        <FormComp
                            title="MATRÍCULA"
                            type="numberOnly"
                            changeFunc={(e) => setMatricula(e.target.value)}
                            valor={matricula}
                            maxLength={6}
                            required
                        />
                        <FormComp
                            title="NOME"
                            type="text"
                            readOnly
                            valor={nome}
                        />
                        <FormComp
                            title="FUNÇÃO"
                            type="text"
                            readOnly
                            valor={funcao}
                        />
                        <FormComp
                            title="APELIDO"
                            type="text"
                            changeFunc={(e) => setApelido(e.target.value.toUpperCase())}
                            valor={apelido}
                            required
                        />
                        <MultiFileUploader
                            files={files}
                            setFiles={setFiles}
                            maxFiles={1}
                            accept="image/*"
                        />
                        <FormComp
                            valor="SALVAR"
                            type="submit"
                        />
                    </Formulario>
                </Modal>
                {loading && (
                    <Overlay state={true} >
                        <Modal size="sm" >
                            <SmallLoading />
                        </Modal>
                    </Overlay>
                )}
            </Overlay>
        </>
    )
}

export default ModalAddCandidato;